import React from "react";
import { useNavigate } from "react-router-dom";
import { SearchBarWr} from "../../../_uiComponents/common/form/UiInputComponents";
import UsersFilterForm from "./forms/UsersFilterForm";
import { MainLeftTitle, CreateButton } from '../../../_uiComponents/WrapperComponents'
import Users from "./Users";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";

export const UsersWrapper = () => {
    const navigate = useNavigate();
    const handleData = () => {
        let path = `/ui/create-user`;
        navigate(path);
    }
    return (
        <>       
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="Users">
                    <CreateButton name="Create Users" onClick={handleData} />
                </MainLeftTitle>
                <UiAccordian>
                    <SearchBarWr>
                        <UsersFilterForm />
                    </SearchBarWr>
                </UiAccordian>

                <Users />
            </div>
        </>
    )
}